var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.dialogTitle,
        width: "1000px",
        top: "6vh",
        "append-to-body": "",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          return _vm.$emit("update:visible", $event)
        },
        open: _vm.handleOpen,
      },
    },
    [
      _c("div", { staticClass: "chat-wrap" }, [
        _c("div", { staticClass: "chat-side" }, [
          _c(
            "div",
            { staticClass: "chat-side__head" },
            [
              _c("span", [
                _vm._v("AI 会话（" + _vm._s(_vm.conversationTotal) + "）"),
              ]),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "text",
                    size: "mini",
                    icon: "el-icon-refresh",
                  },
                  on: { click: _vm.loadConversations },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.conversationLoading,
                  expression: "conversationLoading",
                },
              ],
              staticClass: "chat-side__list",
            },
            [
              _vm._l(_vm.conversations, function (item) {
                return _c(
                  "div",
                  {
                    key: item.id,
                    staticClass: "chat-side__item",
                    class: {
                      "chat-side__item--active": item.id === _vm.activeId,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectConversation(item)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "chat-side__title" },
                      [
                        _c("span", [
                          _vm._v(_vm._s(item.title || "未命名会话")),
                        ]),
                        item.status === "DELETED"
                          ? _c(
                              "el-tag",
                              { attrs: { size: "mini", type: "info" } },
                              [_vm._v("已删除")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "chat-side__meta" }, [
                      _c("span", [
                        _vm._v(_vm._s(item.lastMessageAt || item.createTime)),
                      ]),
                    ]),
                    _c("div", { staticClass: "chat-side__meta" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.formatNumber(item.messageCount)) +
                            " 条消息"
                        ),
                      ]),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.formatNumber(item.tokens)) + " token"
                        ),
                      ]),
                    ]),
                  ]
                )
              }),
              !_vm.conversationLoading && _vm.conversations.length === 0
                ? _c("div", { staticClass: "chat-empty" }, [
                    _vm._v("该用户暂无 AI 会话"),
                  ])
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "chat-side__pager" },
            [
              _c("el-pagination", {
                attrs: {
                  small: "",
                  layout: "prev, pager, next",
                  total: _vm.conversationTotal,
                  "page-size": _vm.conversationFrom.limit,
                  "current-page": _vm.conversationFrom.page,
                },
                on: { "current-change": _vm.handleConversationPageChange },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "chat-main" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.messageLoading,
                  expression: "messageLoading",
                },
              ],
              staticClass: "chat-main__messages",
            },
            [
              _vm._l(_vm.messages, function (msg) {
                return _c(
                  "div",
                  {
                    key: msg.id,
                    staticClass: "chat-msg",
                    class:
                      msg.role === "user" ? "chat-msg--user" : "chat-msg--ai",
                  },
                  [
                    _c("div", { staticClass: "chat-msg__bubble" }, [
                      msg.__rich
                        ? _c("div", {
                            staticClass:
                              "chat-msg__text chat-msg__text--rich markdown-body",
                            domProps: { innerHTML: _vm._s(msg.__richHtml) },
                          })
                        : _c("div", { staticClass: "chat-msg__text" }, [
                            _vm._v(_vm._s(msg.content)),
                          ]),
                      msg.__cards.length
                        ? _c(
                            "div",
                            { staticClass: "chat-cards" },
                            _vm._l(msg.__cards, function (card, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "chat-card",
                                  class: "chat-card--" + card.__kind,
                                },
                                [
                                  card.__kind === "entity"
                                    ? [
                                        card.__cover
                                          ? _c(
                                              "el-image",
                                              {
                                                staticClass: "chat-card__cover",
                                                attrs: {
                                                  src: card.__cover,
                                                  fit: "cover",
                                                  "preview-src-list":
                                                    card.__gallery,
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "chat-card__cover-fallback",
                                                    attrs: { slot: "error" },
                                                    slot: "error",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(card.__typeLabel)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "chat-card__cover-fallback",
                                              },
                                              [_vm._v(_vm._s(card.__typeLabel))]
                                            ),
                                        _c(
                                          "div",
                                          { staticClass: "chat-card__body" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "chat-card__title",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(card.title || "未命名")
                                                ),
                                              ]
                                            ),
                                            card.__meta
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "chat-card__meta",
                                                  },
                                                  [_vm._v(_vm._s(card.__meta))]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "chat-card__tags",
                                              },
                                              [
                                                _c(
                                                  "el-tag",
                                                  {
                                                    attrs: {
                                                      size: "mini",
                                                      type: "info",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(card.__typeLabel)
                                                    ),
                                                  ]
                                                ),
                                                card.id
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "chat-card__id",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "ID " +
                                                            _vm._s(card.id)
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                card.__applyHint
                                                  ? _c(
                                                      "el-tag",
                                                      {
                                                        attrs: {
                                                          size: "mini",
                                                          type: card.__applyTone,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            card.__applyHint
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    : card.__kind === "stat"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "chat-card__body" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "chat-card__title",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(card.title || "统计")
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "chat-card__stats",
                                              },
                                              _vm._l(
                                                card.__stats,
                                                function (item, i) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: i,
                                                      staticClass:
                                                        "chat-card__stat",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "chat-card__stat-value",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.value)
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "chat-card__stat-label",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.label)
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            card.__meta
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "chat-card__meta",
                                                  },
                                                  [_vm._v(_vm._s(card.__meta))]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    : card.__kind === "notice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "chat-card__body" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "chat-card__title",
                                              },
                                              [_vm._v(_vm._s(card.__typeLabel))]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "chat-card__message",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    card.message ||
                                                      "（无附加说明）"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : [
                                        _c(
                                          "div",
                                          { staticClass: "chat-card__body" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "chat-card__title",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    card.title ||
                                                      card.__typeLabel
                                                  )
                                                ),
                                              ]
                                            ),
                                            card.__meta
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "chat-card__meta",
                                                  },
                                                  [_vm._v(_vm._s(card.__meta))]
                                                )
                                              : _vm._e(),
                                            card.message
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "chat-card__message",
                                                  },
                                                  [_vm._v(_vm._s(card.message))]
                                                )
                                              : _vm._e(),
                                            card.__summaryRows.length
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "chat-card__summary",
                                                  },
                                                  _vm._l(
                                                    card.__summaryRows,
                                                    function (row, i) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: i,
                                                          staticClass:
                                                            "chat-card__summary-row",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "chat-card__summary-key",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(row.key)
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "chat-card__summary-value",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  row.value
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm._e(),
                                            card.__archives.length
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "chat-card__archives",
                                                  },
                                                  _vm._l(
                                                    card.__archives,
                                                    function (arc) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: arc.id,
                                                          staticClass:
                                                            "chat-card__archive",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "chat-card__archive-title",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  arc.title ||
                                                                    "档案"
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          arc.__summary
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "chat-card__archive-meta",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      arc.__summary
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm._e(),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "chat-card__tags",
                                              },
                                              [
                                                _c(
                                                  "el-tag",
                                                  {
                                                    attrs: {
                                                      size: "mini",
                                                      type: "info",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(card.__typeLabel)
                                                    ),
                                                  ]
                                                ),
                                                card.status
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "chat-card__id",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(card.status)
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ],
                                ],
                                2
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm.hasMedia(msg)
                        ? _c(
                            "div",
                            { staticClass: "chat-msg__media" },
                            _vm._l(msg.__media, function (item) {
                              return _c(
                                "div",
                                {
                                  key: item.__key,
                                  staticClass: "chat-msg__media-item",
                                },
                                [
                                  item.available
                                    ? _c(
                                        "el-image",
                                        {
                                          staticClass: "chat-msg__media-img",
                                          attrs: {
                                            src: item.url,
                                            fit: "cover",
                                            "preview-src-list": _vm.previewList(
                                              msg.__media
                                            ),
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "chat-msg__media-missing",
                                              attrs: { slot: "error" },
                                              slot: "error",
                                            },
                                            [_vm._v("加载失败")]
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "chat-msg__media-missing",
                                        },
                                        [_vm._v("图片已过期")]
                                      ),
                                  _c(
                                    "div",
                                    { staticClass: "chat-msg__media-meta" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.available
                                            ? item.__sizeText
                                            : "已清理"
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "chat-msg__time" }, [
                      _vm._v(
                        " " +
                          _vm._s(msg.role === "user" ? "用户" : "AI") +
                          " · " +
                          _vm._s(msg.createTime) +
                          " · " +
                          _vm._s(msg.status) +
                          " "
                      ),
                    ]),
                  ]
                )
              }),
              !_vm.messageLoading && _vm.messages.length === 0
                ? _c("div", { staticClass: "chat-empty" }, [
                    _vm._v("请选择左侧会话查看聊天记录"),
                  ])
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "chat-main__pager" },
            [
              _c("el-pagination", {
                attrs: {
                  small: "",
                  layout: "total, prev, pager, next",
                  total: _vm.messageTotal,
                  "page-size": _vm.messageFrom.limit,
                  "current-page": _vm.messageFrom.page,
                },
                on: { "current-change": _vm.handleMessagePageChange },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }